    import React, { useState, useEffect } from 'react';
    import debounce from 'lodash/debounce'; // یا import { debounce } from 'lodash';

    const SearchBox = ({ onSearch }) => {
      const [inputValue, setInputValue] = useState('');

      // تابع debounce شده برای onSearch
      const debouncedSearch = React.useMemo(
        () => debounce((searchValue) => {
          onSearch(searchValue);
        }, 500), // 500 میلی‌ثانیه تاخیر
        [onSearch] // این تابع فقط زمانی دوباره ساخته می‌شود که onSearch تغییر کند
      );

      useEffect(() => {
        debouncedSearch(inputValue);
        // در زمان unmount شدن کامپوننت، debounce را cancel کنید
        return () => {
          debouncedSearch.cancel();
        };
      }, [inputValue, debouncedSearch]); // اجرای effect هنگام تغییر inputValue

      const handleChange = (event) => {
        setInputValue(event.target.value);
      };

      return (
        <div className="relative mb-6">
          <input
            type="text"
            placeholder="جستجو در سفارشات (شماره یا نام کالا)..."
            value={inputValue}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 pl-10"
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </div>
        </div>
      );
    };

    export default SearchBox;
